// §6.8 threshold initial values — tune after measurement
export const TOKEN_BUCKET_RATE = 8;       // tokens/sec sustained
export const TOKEN_BUCKET_BURST = 80;     // initial burst capacity
export const AUTH_HARDSTOP_K = 3;         // consecutive 401/403 before hardstop
export const CB_FAILURE_K = 5;            // per-endpoint failures before open
export const CB_COOLDOWN_MS = 30_000;     // 30s CB cooldown

// 401 codes: immediate hardstop (no K-consecutive counting)
// Others (AUTH_001-020 etc.) are provisional — K-consecutive threshold applies
// 403 PLAN_001 = business rejection only (NOT auth failure, not in this list)
export const CONFIRMED_401_CODES = ['TOKEN_EXPIRED'] as const;
